import validate from "/home/vsts/work/1/s/src/gmp-swa/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.1_@types+node@18.19.101_db0@0.3.2_eslint@9.27.0_jiti@2._045bc9a16a17b62930e6526d584bd9bd/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/home/vsts/work/1/s/src/gmp-swa/middleware/01.auth.global.ts";
import _02_45guardian_45global from "/home/vsts/work/1/s/src/gmp-swa/middleware/02.guardian.global.ts";
import _03_45persist_45query_45params_45global from "/home/vsts/work/1/s/src/gmp-swa/middleware/03.persist-query-params.global.ts";
import _04_45redirect_45global from "/home/vsts/work/1/s/src/gmp-swa/middleware/04.redirect.global.ts";
import manifest_45route_45rule from "/home/vsts/work/1/s/src/gmp-swa/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.1_@types+node@18.19.101_db0@0.3.2_eslint@9.27.0_jiti@2._045bc9a16a17b62930e6526d584bd9bd/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45guardian_45global,
  _03_45persist_45query_45params_45global,
  _04_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}